export default from './Strong';



// WEBPACK FOOTER //
// ./src/components/atoms/Strong/index.js